import { useEffect, useState } from 'react';
import {
  Container,
  UpperContainer,
  BottomContainer,
  Title,
  Description,
  CustomLink,
  ButtonContainer,
  ImageContainer,
} from './blackBox.style';
import { IBlackBoxCard } from './blackBoxCard.model';
import { Button, ImageAtoms } from '@vfit/shared/atoms';
import { ExitIcon } from '@vfit/shared-icons';
import { purifyTextWithLogo, trackLink } from '@vfit/shared/data-access';
import BlackBoxTagging from './blackBox.tagging';
import { purify } from '@vfit/shared/themes';

const BlackBoxCard = (props: IBlackBoxCard) => {
  const [isLoading, setIsLoading] = useState(true);
  const {
    title,
    liteTitle,
    description,
    buttonLabel,
    timeToShow,
    showX,
    imageReducedSrc,
    imageSrc,
  } = props?.blackBoxConfig || {};
  const [pTitle, pLiteTitle, pDescription] = purify(
    [title || '', liteTitle, description || ''],
    purifyTextWithLogo
  );
  const [reducedBox, setReducedBox] = useState(false);

  const reduceBlackBox = () => {
    trackLink(
      'reduce black box',
      'users',
      'click',
      'ui-interaction',
      'link',
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      {
        ...(props?.trackObj?.event_label_track && {
          page_name_override: props?.trackObj?.event_label_track,
        }),
        ...(props?.trackObj?.product_technology && {
          product_technology: props?.trackObj?.product_technology,
        }),
      }
    );
    setReducedBox(true);
  };

  const onActionClick = () => {
    trackLink(
      buttonLabel || 'Scopri le offerte fastweb',
      'users',
      'click',
      'ui-interaction',
      'link',
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      {
        ...(props?.trackObj?.event_label_track && {
          page_name_override: props?.trackObj?.event_label_track,
        }),
        ...(props?.trackObj?.product_technology && {
          product_technology: props?.trackObj?.product_technology,
        }),
      }
    );
    props?.onClickButton?.();
  };

  useEffect(() => {
    if (timeToShow) {
      setTimeout(() => {
        setIsLoading(false);
      }, timeToShow * 1000);
    } else {
      setIsLoading(false);
    }
  }, []);

  if (isLoading) return <div />;

  return (
    <>
      {props?.trackObj && <BlackBoxTagging {...props?.trackObj} />}
      <Container reducedBox={reducedBox}>
        <UpperContainer>
          <ImageContainer
            key={reducedBox ? 'container-reduced' : 'container-expanded'}
            reducedBox={reducedBox}
          >
            {reducedBox ? (
              <ImageAtoms nameCard={'logo-reduced'} image={imageReducedSrc} />
            ) : (
              <ImageAtoms nameCard={'logo-expanded'} image={imageSrc} />
            )}
          </ImageContainer>
          {showX && !reducedBox && (
            <div>
              <span
                style={{
                  width: 24,
                  height: 24,
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
                role="button"
                tabIndex={0}
                className="closing-icon"
                onClick={() => reduceBlackBox()}
              >
                <ExitIcon stroke="white" />
              </span>
            </div>
          )}
        </UpperContainer>
        <BottomContainer reducedBox={reducedBox}>
          {pTitle && !reducedBox && (
            <Title reducedBox={false} dangerouslySetInnerHTML={{ __html: pTitle }} />
          )}
          {pLiteTitle && reducedBox && (
            <>
              <Title reducedBox dangerouslySetInnerHTML={{ __html: pLiteTitle }} />
              {buttonLabel && <CustomLink onClick={onActionClick}>{buttonLabel}</CustomLink>}
            </>
          )}
          {!reducedBox && pDescription && (
            <Description
              dangerouslySetInnerHTML={{
                __html: pDescription || '',
              }}
            />
          )}
          <ButtonContainer reducedBox={reducedBox}>
            <Button onClick={onActionClick}>{buttonLabel}</Button>
          </ButtonContainer>
        </BottomContainer>
      </Container>
    </>
  );
};

export default BlackBoxCard;
